import {createApp} from 'vue';
import App from './App.vue';

import router from './router';
import store from './store';

import Toaster from '@meforma/vue-toaster';
import moment from 'moment';
import 'moment/locale/de'; // only include German
moment.locale('de');

import {VueDatePicker} from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import 'bootstrap';
// Import BS 5.0 sass directly in App.vue

const app = createApp(App);

app.config.globalProperties.$filters = {
	formatMonth(value) {
		if (value) {
			const dateParsed = moment(String(value));
			if (dateParsed.isValid()) {
				return dateParsed.format('YYYY-MM');
			}
		}
		return '';
	},
	formatMonthStringToDateObj(str) {
		if (typeof str !== 'string') return null;
		const m = str.trim();
		// Match year-month optionally followed by -DD and optional time part
		// ^(\d{4})-(\d{1,2})(?:-\d{1,2}(?:\s+\d{1,2}:\d{2}:\d{2})?)?$
		const match = m.match(/^(\d{4})-(\d{1,2})(?:-\d{1,2}(?:\s+\d{1,2}:\d{2}:\d{2})?)?$/);
		if (!match) return null;
		const year = Number(match[1]);
		const month = Number(match[2]) - 1;
		if (!Number.isFinite(year) || month < 0 || month > 11) return null;
		return {year, month};
	},
	formatMonthDateObjToString(obj, additionalString = true) {
		if (!obj || typeof obj.year === 'undefined' || typeof obj.month === 'undefined' || obj.year === null || obj.month === null) {
			return null;
		}
		const monthPadded = String(obj.month + 1).padStart(2, '0');
		return additionalString ? `${obj.year}-${monthPadded}-01 00:00:00` : `${obj.year}-${monthPadded}`;
	},
	formatDate(value) {
		if (value) {
			const dateParsed = moment(String(value));
			if (dateParsed.isValid()) {
				return dateParsed.format('YYYY-MM-DD');
			}
		}
		return '';
	},
	formatDateTime(value) {
		if (value) {
			const dateParsed = moment(String(value));
			if (dateParsed.isValid()) {
				return dateParsed.format('DD.MM.YYYY, HH:mm');
			}
		}
		return '';
	},
	todayDate() {
		return moment().format('YYYY-MM-DD');
	},
	currentMonth() {
		return moment().format('YYYY-MM');
	},
	nextMonthFrom(monthStr) {
		return moment(monthStr, 'YYYY-MM').add(1, 'month').format('YYYY-MM');
	},
	previousMonthFrom(monthStr) {
		return moment(monthStr, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
	},
	formatHumanReadableDate(value) {
		return moment(String(value)).format('DD.MM.YYYY');
	},
	formatHumanReadableMonth(value) {
		return moment(String(value)).format('MMMM YYYY');
	},
	globalOptionsIntervall() {
		return {
			month: 'Monat',
			quarter: 'Quartal',
			halfyear: 'Halbjährlich',
			year: 'Jahr',
		};
	},
	budgetOptionsIntervall() {
		return {
			year: 'Jährlich',
			twoyears: 'Alle 2 Jahre',
		};
	},
};

app.use(router).use(store).use(Toaster, {position: 'top'}).component('VueDatePicker', VueDatePicker).mount('#app');
